
import { StringUuid } from "../domain/model/uuid/string-uuid";
import { Uuid } from "../domain/model/uuid/uuid.type";

export function stringIdsToUuids(ids: string[]): Uuid[] {
  return ids.map((id) => new StringUuid(id));
}